/**
 * Converts hex color with opacity to RRGGBBAA format
 *
 * @param {string} color Color in hex with #
 * @param {number} opacity Opacity number in percent decimal
 *
 * @return {string} Value in RRGGBBAA
 */
const hexToRrggbbaa = (color: string, opacity: number): string => {
  const opacityHex = Math.round(opacity * 255).toString(16); // Accounting for opacity < 10%;

  const prefixedOpacityHex =
    opacityHex.length > 1 ? opacityHex : `0${opacityHex}`;
  return `${color}${prefixedOpacityHex}`;
};

export default hexToRrggbbaa;
